import React from 'react';
import { Search, Settings, AlertCircle, Download, Check, LayoutGrid, List } from 'lucide-react';
import { APP_VERSION } from '../api/client';

const Header = ({ 
    styles, 
    search, 
    setSearch, 
    showFilters, 
    setShowFilters, 
    handleExport, 
    checkVersion, 
    serverVersion, 
    versionMismatch,
    viewMode,
    setViewMode
}) => {
    return (
        <>
            <header style={styles.header}>
                <div style={styles.titleGroup}>
                    <h1 style={styles.title}>Home Inven</h1>
                    <div 
                        style={{
                            ...styles.versionBadge, 
                            backgroundColor: versionMismatch ? '#ffeba1' : '#f0f0f0',
                            color: versionMismatch ? '#856404' : '#888'
                        }}
                        onClick={checkVersion}
                        title={`Server: ${serverVersion || 'Checking...'}`}
                    >
                        v{APP_VERSION}
                        {versionMismatch && <AlertCircle size={12} style={{marginLeft: '4px'}} />}
                    </div>
                </div>
                <button onClick={handleExport} style={styles.exportBtn}>
                    <Download size={14} />
                    <span style={{fontSize: '12px', fontWeight: '600'}}>Excel</span>
                </button>
            </header>

            <div style={styles.searchBar}>
                <div style={styles.searchForm}>
                    <Search size={18} color="#999" />
                    <input 
                        type="text" 
                        placeholder="검색어 입력 (초성 가능)" 
                        style={styles.searchInput}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <button 
                    style={{...styles.iconBtn, color: showFilters ? '#000' : '#999', backgroundColor: showFilters ? '#eee' : 'transparent', borderRadius: '50%', padding: '8px'}}
                    onClick={() => setShowFilters(!showFilters)}
                >
                    <Settings size={20} />
                </button>
                <button 
                    style={{...styles.iconBtn, color: '#999', backgroundColor: 'transparent', borderRadius: '50%', padding: '8px', marginLeft: '4px'}}
                    onClick={() => setViewMode(viewMode === 'list' ? 'grid' : 'list')}
                >
                    {viewMode === 'list' ? <LayoutGrid size={20} /> : <List size={20} />}
                </button>
            </div>
        </>
    );
};

export default Header;
